import { FC } from "react";

import { SKUPageContentTabType, WebpageTabOptions } from "@/data/types";

import { CMSTab } from "./cms-tab";
import { CMSTabProvider } from "./cms-tab-context";
import WebpageTabSettings from "./webpage-tab/webpage-tab-settings";

type Props = {
  index: number;
  options: WebpageTabOptions;
};

export const CMSWebpageTab: FC<Props> = ({ index, options }) => {
  return (
    <CMSTabProvider
      tabType={SKUPageContentTabType.WEBPAGE_TAB}
      tabIndex={index}
    >
      <CMSTab options={options}>
        <WebpageTabSettings options={options} />
      </CMSTab>
    </CMSTabProvider>
  );
};
